import { jsx as r } from "react/jsx-runtime";
import a from "../../../../../../node_modules/@ant-design/react-slick/es/slider.mjs";
import { SliderArrow as o, SliderArrowEnum as l } from "./slider-arrow.mjs";
import d from "react";
import f from "./dot.mjs";
const p = d.forwardRef(
  ({ images: e, goToSlide: n }, s) => {
    if (!e || e.length === 0) return null;
    const t = e.length > 1;
    return /* @__PURE__ */ r(
      a,
      {
        ref: s,
        swipe: t,
        arrows: t,
        infinite: t,
        swipeToSlide: t,
        dots: t,
        prevArrow: /* @__PURE__ */ r(o, { variant: l.left }),
        nextArrow: /* @__PURE__ */ r(o, { variant: l.right }),
        customPaging: (i) => /* @__PURE__ */ r(f, { slidesCount: e.length, index: i, goToSlide: n }),
        dotsClass: "relative bottom-5 !flex flex-row justify-center items-center gap-[9px] w-[calc(100%-90px)] max-w-[120px] mx-auto",
        children: e.map(({ path: i, id: m }) => /* @__PURE__ */ r("div", { className: "!flex items-center justify-center", children: /* @__PURE__ */ r("img", { src: i }) }, m))
      }
    );
  }
);
p.displayName = "Slider";
export {
  p as Slider
};
